import styled from 'styled-components';

import { Color, FontWeight } from '../../theme';

export const Button = styled.button`
  padding: 20px 60px;
  color: ${Color.white};
  font-size: 16px;
  font-weight: ${FontWeight.Medium};
  letter-spacing: 0;
  line-height: 20px;
  border: 1px solid ${Color.white};
  background-color: transparent;
  transition: background 0.2s;
  cursor: pointer;
  &:hover {
    background-color: ${Color.darkGrey};
    border-color: ${Color.darkGrey};
  }
`;
